import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { without, forEach } from "lodash"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeForecast", {
  focusChartLine: {
    props: ["focusedChartLine"],
    track: false,
  },
  blurChartLine: { track: false },
  selectFactorCategory: {
    props: ["factorId"],
    trackType: "composite-analyze-forecast-category-selection",
  },
  toggle: {
    props: ["id", "currentState"],
    trackType: "composite-analyze-forecast-graph-legend-factor",
    trackPayload: ({ id, currentState }) => ({ factor: id, state: currentState ? "on" : "off" }),
  },
  toggleOnly: {
    props: ["id", "contentSetId"],
    trackType: "composite-analyze-forecast-graph-legend-factor",
    trackPayload: ({ id, contentSetId }) => ({ factor: id, contentSetId }),
  },
}, { track: true })

const INITIAL_STATE = {
  focusedChartLine: null,
}

const handleToggle = (state, { factorId, currentState }) => ({
  ...state,
  focusedChartLine: currentState ? factorId : null,
})

const handleToggleOnly = (state, { factorId, only }) => ({
  ...state,
  focusedChartLine: only ? factorId : null,
})

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

export default createReducer(INITIAL_STATE, {
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.TOGGLE]: handleToggle,
  [Types.TOGGLE_ONLY]: handleToggleOnly,
})

const resetGraphState = (state) => ({
  ...state,
  disabled: null,
  only: null,
  focusedChartLine: null,
})

const handleSelectFactorCategory = (state, { factorId }) => ({
  ...resetGraphState(state),
  factorCategory: factorId,
})

const handleToggleQS = (state, { factorId, currentState }) => ({
  ...state,
  only: null,
  disabled: currentState ? without(state.disabled, factorId) : [...(state.disabled || []), factorId],
})

const handleToggleOnlyQS = (state, { factorId, only, items }) => {
  const disabled = []
  let onlyDisplay = null

  if (only) {
    onlyDisplay = factorId
    forEach(items, item => {
      if (item.id !== factorId) {
        disabled.push(item.id)
      }
    })
  }

  return { ...state, disabled, only: onlyDisplay }
}

export const queryStringReducers = {
  [Types.SELECT_FACTOR_CATEGORY]: handleSelectFactorCategory,
  [Types.TOGGLE]: handleToggleQS,
  [Types.TOGGLE_ONLY]: handleToggleOnlyQS,
}
